import { render, staticRenderFns } from "./p_tech035.vue?vue&type=template&id=47fa5a08&scoped=true&"
import script from "./p_tech035.vue?vue&type=script&lang=js&"
export * from "./p_tech035.vue?vue&type=script&lang=js&"
import style0 from "./p_tech035.vue?vue&type=style&index=0&id=47fa5a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fa5a08",
  null
  
)

export default component.exports